/*
 * @Author: ze.wang@diact.com
 * @Date: 2022-11-24 15:13:06
 * @Function: Please Input Function
 */
const validateAnswer = function (errors, vm, showTip) {
  const { value, answerConfig: { requireInd } } = this
  let { mediaQuType, answerConfig: { useText, minAnswerNum, maxAnswerNum, validateRuleType, validateRuleValue } } = this
  // 必答题
  if (requireInd === '1') {
    // 未作答
    if (!value || value.length === 0) {
      errors.push(vm.cvtLang('tipAnswerNull', vm.surveyInfoLang.tipAnswerNull))
      return !errors.length
    }
    
    // if(useText === '1'){
      for(let i=0;i<value.length;i++){
        if(!value[i].url){
          if(!value[i].openAnswer.trim()){
            errors.push(vm.cvtLang('tipAnswerNull', vm.surveyInfoLang.tipAnswerNull))
            return !errors.length
          }
        }
      }
    // }
  }

  return !errors.length
}

const validate = function (vm, showTip) {
  const errors = []
  return {
    result: validateAnswer.call(this, errors, vm, showTip),
    errors
  }
}

const answerValidate = {
  validateAnswer,
  validate
}

export default answerValidate



// WEBPACK FOOTER //
// ./src/components/editor/MusicBox/answerValidate.js